import React from 'react';
import {CoreProps, ModuleInjectedProps, PaymentModule} from './types';
import {CoreHeader} from './components/CoreHeader';
import {CoreResume as CoreResumeComponent} from './components/CoreResume';
import {CoreGasStations} from './components/CoreGasStations';

function CoreComponent(_props: CoreProps) {
  return null;
}

CoreComponent.Header = CoreHeader;

CoreComponent.Resume = function Resume({
  pedidos,
  localidade,
  discount,
  posto,
  stationsByProductId,
  cashback,
  totalValue,
  serviceTaxValue,
  serviceTaxIsCard,
  usaBaratinhas,
  descontoBaratinhas,
}: CoreProps & ModuleInjectedProps) {
  return (
    <>
      <CoreResumeComponent
        cashback={cashback}
        totalValue={totalValue}
        discount={discount}
        isCreditCard={serviceTaxIsCard}
        localidade={localidade}
        pedidos={pedidos}
        serviceTaxValue={serviceTaxValue}
        usaBaratinhas={usaBaratinhas}
        descontoBaratinhas={descontoBaratinhas}
      />
      {posto && (
        <CoreGasStations
          localidade={localidade}
          posto={posto}
          stationsByProductId={stationsByProductId}
        />
      )}
    </>
  );
};

export const Core = CoreComponent as PaymentModule<CoreProps>;
